document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".recommendation-addtocart");
  if (!btn) return;

  const card = btn.closest(".recommendation-item");
  const info = card.querySelector(".product--info");
  const cartDrawer = document.querySelector("cart-drawer");

  btn.disabled = true;

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: btn.dataset.variantId,
        quantity: 1,
        properties: {
          _parent_id: info?.dataset.parentId || "",
          _parent_name: info?.dataset.parentName || "",
          _affiliation: info?.dataset.origin || "",
          _treatment: info?.dataset.treatment || "",
          _listing: info?.dataset.publish || ""
        },
        sections: cartDrawer.getSectionsToRender().map(section => section.id),
        sections_url: window.location.pathname
      })
    });

    if (!response.ok) throw new Error("Failed to add product");

    const parsedState = await response.json();

    // Update Cart Drawer
    cartDrawer.renderContents(parsedState);

    // ---------- GA4 ----------
    const item = {
      item_id: info?.dataset.sku || "",
      item_name: info?.dataset.title || "",
      index: parseInt(info?.dataset.index || 0),
      affiliation: info?.dataset.origin || "",
      item_category: info?.dataset.type || "",
      item_category2: info?.dataset.treatment || "",
      item_variant: info?.dataset.size || "",
      item_list_id: info?.dataset.parentId || "",
      item_list_name: info?.dataset.parentName || "",
      price: parseFloat(info?.dataset.price || 0),
      quantity: 1,
      item_brand: "Gemstones For Sale",
      coupon: "NA",
      listing_date: info?.dataset.publish || "",
      discount: 0
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
      event: "add_to_cart_ce",
      page_type: window.GA_CONTEXT?.page_type || "",
      platform: window.matchMedia("(max-width:768px)").matches ? "m-web" : "d-web",
      total_qty: 1,
      user_id_event: window.GA_CONTEXT?.user_id,
      user_status: window.GA_CONTEXT?.user_status || "guest",
      ecommerce: {
        currency: "USD",
        value: item.price,
        items: [item]
      }
    });

    // ---------- Shopify Customer Events ----------
    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish("ga4_product_context", {
        item_list_id: item.item_list_id,
        item_list_name: item.item_list_name,
        item_category2: item.item_category2,
        affiliation: item.affiliation,
        listing_date: item.listing_date,
        index: item.index
      });
    }

    btn.classList.add("add_cart_success");
    btn.innerHTML = "✔";

    setTimeout(() => {
      btn.classList.remove("add_cart_success");
      btn.innerHTML = `
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10">
            <path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"/>
          </svg>
        </span>`;
    }, 2000);

  } catch (err) {
    console.error(err);
  } finally {
    btn.disabled = false;
  }
});